import { Injectable } from '@angular/core';
import { Signup } from '@app/_models';
import { PaymentVerifyRequest, PaymentVerifyResponse, PaymentSummaryRequest, PaymentSummaryResponse } from '@app/_models/signups/payment';
import { environment } from '@environments/environment';
import { PaymentReauthorize } from '@app/_models/signups/payment/paymentreauthorizerequest';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const baseUrl = `${environment.apiUrl}/api/payment`;

@Injectable({ providedIn: 'root' })
export class PaymentService {

  constructor(private http: HttpClient) { }

  verify(signup: Signup): Observable<PaymentVerifyResponse> {
    return this.http.post<PaymentVerifyResponse>(`${baseUrl}/verify`, new PaymentVerifyRequest(signup));
  }

  summary(orderInfo: any): Observable<PaymentSummaryResponse> {
    var req = new PaymentSummaryRequest(orderInfo);

    req.order = orderInfo.order;

    return this.http.post<PaymentSummaryResponse>(`${baseUrl}/summary`, req);
  }

  clientSummary(orderInfo: any): Observable<PaymentSummaryResponse> {
    var req = new PaymentSummaryRequest(orderInfo);
    req.order = orderInfo;
    return this.http.post<PaymentSummaryResponse>(`${baseUrl}/client-summary`, req);
  }
  
  verifyUpdate(form: any): Observable<PaymentVerifyResponse> {
    return this.http.post<PaymentVerifyResponse>(`${baseUrl}/verify-update`, new PaymentReauthorize(form));
  }

}
